import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _, { isFunction } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import QCXAutocompleteSelect from '../../../../shared-components/autocomplete-select/QCXAutocompleteSelect';

export default function SelectFundamentosOpcionais({
  listFundamentos = [],
  name="",
  values={},
  disabled,
  ...restProps
}) {

  const [defaultValue, setDefaultValue] = useState('');

  useEffect(() => {
    console.log(`name : ${name}`)
  }, [name])

  useEffect(() => {
    const value = listFundamentos.find((item) => item?.id === _.get(values, name));
    if (value) {
      setDefaultValue(value);
    } else {
      setDefaultValue({ id: null, description: '' });
    }
  }, [listFundamentos, values]);

  const filterOptions = createFilterOptions({
    stringify: (item) => `${item?.id} - ${item?.nome}`,
  });


  return (
    <QCXAutocompleteSelect
      label="Fundamento Legal Opcional"
      id={name}
      name={name}
      disabled={disabled}
      options={listFundamentos}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={(item) => (
        item?.id && item?.nome
          ? `${item?.id} - ${item?.nome}`
          : ''
      )}
      {...restProps}
    />
  );
}